import { applyTokens } from "../../../utilities/applyTokens.js";
const setLensIconSize = (tokens, size) => {
    var _a;
    const { semantic: { iconSize: iconSizes }, } = tokens;
    const key = (_a = Object.entries(iconSizes).find(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ([_, value]) => value.value === size)) === null || _a === void 0 ? void 0 : _a[0];
    return key
        ? {
            "--atlas-icon-size": key,
        }
        : undefined;
};
const createOffsetPadding = (padding) => `calc(${padding} - var(--padding-offset))`;
const createSize = (tokens, size) => {
    const { component: { buttonSegmented }, } = tokens;
    const sizeTokens = buttonSegmented[size];
    return Object.assign(Object.assign(Object.assign({}, applyTokens(sizeTokens)), { 
        // To imitate Figma's ability to draw borders "inside" the element,
        // we need to offset the padding by the border width
        paddingLeft: createOffsetPadding(sizeTokens.paddingLeft.value), paddingRight: createOffsetPadding(sizeTokens.paddingRight.value), "&:first-of-type": applyTokens(sizeTokens.first), "&:last-of-type": applyTokens(sizeTokens.last), "& > svg": Object.assign({ flexShrink: 0 }, applyTokens(sizeTokens.icon)), ":has(> svg:only-child)": applyTokens(sizeTokens.iconOnly), ":has(> svg + span)": {
            paddingLeft: createOffsetPadding(sizeTokens.withLeadingIcon.paddingLeft.value),
        }, ":has(> span + svg)": {
            paddingRight: createOffsetPadding(sizeTokens.withTrailingIcon.paddingRight.value),
        } }), setLensIconSize(tokens, sizeTokens.icon.height.value));
};
const createState = (tokens, state) => {
    const { component: { buttonSegmented }, } = tokens;
    const stateTokens = buttonSegmented[state];
    return Object.assign(Object.assign({}, applyTokens(stateTokens.default)), { "&:hover": applyTokens(stateTokens.hover), "&:active": applyTokens(stateTokens.active), "&.Mui-disabled": applyTokens(stateTokens.disabled), "--padding-offset": stateTokens.default.borderWidth.value });
};
const toggleButton = (tokens) => {
    const { component: { buttonSegmented: { unselected }, }, } = tokens;
    return {
        MuiToggleButtonGroup: {
            styleOverrides: {
                root: {
                    " .MuiToggleButtonGroup-grouped:not(:first-of-type)": {
                        borderLeftColor: unselected.default.borderColor.value,
                        "&.Mui-disabled": {
                            borderLeftColor: unselected.disabled.borderColor.value,
                        },
                    },
                },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: Object.assign(Object.assign({}, createState(tokens, "unselected")), { "&.Mui-selected": createState(tokens, "selected"), "&:focus": {
                        position: "relative",
                        zIndex: 1,
                    } }),
                sizeMedium: createSize(tokens, "medium"),
                sizeSmall: createSize(tokens, "small"),
            },
        },
    };
};
export default toggleButton;
//# sourceMappingURL=toggleButton.js.map